import { render, staticRenderFns } from "./ClientTimeOverview.vue?vue&type=template&id=1b245687"
import script from "./ClientTimeOverview.vue?vue&type=script&lang=js"
export * from "./ClientTimeOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports